import { ENTITY_TOOLBAR_HEIGHT } from "components/lib/EntityHeader";
import { Toaster as ToastContainer } from "components/lib/Toast";
import { NAV_BAR_HEIGHT } from "components/lib/UI";

const Toaster = () => (
  <ToastContainer
    position="top-right"
    // Below the nav bar and toolbar, so toasts never cover a toolbar's Save.
    containerStyle={{
      top: NAV_BAR_HEIGHT + ENTITY_TOOLBAR_HEIGHT + 5,
      right: 5,
    }}
    toastOptions={{
      duration: 5000,
      style: {
        padding: "10px 20px",
        fontSize: "20px",
        border: "0.5px solid #e9ebee",
        borderRight: "2px solid #4582d3",
      },
      success: {
        style: {
          border: "0.5px solid #e9ebee",
          borderRight: "2px solid #61d345",
        },
      },
      error: {
        style: { borderRight: "2px solid red" },
        ariaProps: { role: "alert", "aria-live": "assertive" },
      },
    }}
  />
);

export default Toaster;
